// src/lib/layouts/newsPostMapping.ts
import type {
  BreakingNewsConfig, ChoqueiConfig, InstagramNewsConfig, NewsPostConfig, NewspaperConfig,
} from './types';
import { pickDefinedHeadlineStyle } from './headlineStyle';

export function toChoqueiConfig(c: NewsPostConfig): ChoqueiConfig {
  return {
    kind: 'choquei',
    brandName: c.brandName,
    headline: c.headline,
    accentColor: c.accentColor,
    logoUrl: c.logoUrl,
    avatarUrl: c.avatarUrl,
    imageUrl: c.imageUrl,
    ...pickDefinedHeadlineStyle(c),
  };
}

export function toBreakingNewsConfig(c: NewsPostConfig): BreakingNewsConfig {
  return {
    kind: 'breaking_news',
    channelName: c.brandName,
    tag: c.tag ?? '',
    headline: c.headline,
    accentColor: c.accentColor,
    logoUrl: c.logoUrl,
    imageUrl: c.imageUrl,
    ...pickDefinedHeadlineStyle(c),
  };
}

export function toNewspaperConfig(c: NewsPostConfig): NewspaperConfig {
  return {
    kind: 'newspaper',
    sourceName: c.brandName,
    headline: c.headline,
    kicker: c.kicker ?? '',
    accentColor: c.accentColor,
    imageUrl: c.imageUrl,
    ...pickDefinedHeadlineStyle(c),
  };
}

export function toInstagramConfig(c: NewsPostConfig): InstagramNewsConfig {
  return {
    kind: 'instagram',
    handle: c.brandName,
    caption: c.headline,
    likes: c.likes ?? '',
    avatarUrl: c.avatarUrl,
    imageUrl: c.imageUrl,
    ...pickDefinedHeadlineStyle(c),
  };
}
